import { z } from "zod";
import { idSchema, quantitySchema } from "../primitives.js";

/**
 * Shared with createSupplierSkuInput (schemas/orders.ts) — both the admin and the supplier
 * self-service sku form fill in the same fields, minus supplierId (admin picks one; a supplier's
 * own route reads it from the session) and plus a required price on the supplier side.
 */
export const skuFields = {
  nameKo: z.string().min(1).max(120),
  nameEn: z.string().max(120).nullish(),
  unit: z.string().min(1).max(20),
  packSize: z.string().max(40).nullish(),
  /** Whether the unit allows decimal quantities, like lb/kg. False for box/piece. */
  isDivisible: z.boolean().default(false),
  /** Order step. e.g. "0.5" for lb, "1" for box. */
  qtyStep: quantitySchema.default("1"),
  // Konglish/mixed spellings (spec §2) — for search/matching
  aliases: z.array(z.string().min(1).max(120)).max(20).default([]),
};

export const createOrgInput = z.object({
  name: z.string().min(1).max(120),
  contactName: z.string().max(80).nullish(),
  phone: z.string().max(40).nullish(),
});

export const createSkuInput = z
  .object({ supplierId: idSchema, ...skuFields })
  .refine((v) => v.isDivisible || Number.isInteger(Number(v.qtyStep)), {
    message: "나눌 수 없는 단위의 주문 단위는 정수여야 합니다",
    path: ["qtyStep"],
  });

export type CreateOrgInput = z.infer<typeof createOrgInput>;
export type CreateSkuInput = z.infer<typeof createSkuInput>;
